export default __webpack_public_path__ + "static/media/feed_mobile_banner.29c1b7a0.png";